import "../style/faq-page.css";
import StyledPage from "./StyledPage";
import Bg from "../assets/faq-bg.png";
import {db} from "../firebase";
import {collection, query, getDocs, orderBy} from "firebase/firestore";
import {useEffect, useState} from "react";
import Expand from "../assets/icon-expand.svg";

interface Faq {
  id: string;
  question: string;
  answer: string;
  createdAt: number;
}

const FaqPage = () => {
  const [faqs, setFaqs] = useState<Faq[]>([]);
  const [expanded, setExpanded] = useState<string[]>([])

  const handleExpandClick = (index: string) => {
    if (expanded.includes(index)) {
      setExpanded(expanded.filter((item) => item !== index) || [])
    } else {
      setExpanded([...expanded, index]);
    }
  }

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const faqCollection = collection(db, "faqs");
        const q = query(faqCollection, orderBy("createdAt", "desc"));
        const querySnapshot = await getDocs(q);
        const faqList: Faq[] = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as Faq[];
        setFaqs(faqList);
      } catch (error) {
        console.error("FAQ 데이터 가져오기 실패:", error);
      }
    };

    fetchFaqs();
  }, []);


  return (
    <StyledPage>
      <div className={'faq-page'}>
        <img className={'faq-bg'} src={Bg} alt={''}/>
        <div className={'faq-page-title-1'}>블루스키스쿨</div>
        <div className={'faq-page-title-2'}>
          Q<span style={{color: '#9FC6FF'}}>&</span>A
        </div>
        <div className={'faq-container'}>
          {faqs.map((faq, index) => (
            <div className={'faq-item'} key={index}>
              <div className={'faq-question-row'} onClick={() => handleExpandClick(index.toString())}>
                <div className={'faq-question-row-left'}>
                  <div className={'faq-question-no'}>{faqs.length - index}</div>
                  <div className={'faq-question'}>{faq.question}</div>
                </div>
                <img className={`faq-question-expand ${expanded.includes(index.toString()) && 'expanded'}`} src={Expand}
                     alt={''}/>
              </div>
              {expanded.includes(index.toString()) && (
                <div className={'faq-answer-container'}>
                  <div className={'divider'}/>
                  <div className={'faq-answer'} key={index}>
                    {faq.answer.split(`<br />`).map((line, index) => (
                      <div>{line}</div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </StyledPage>
  )
}

export default FaqPage;